import { useDispatch } from "react-redux";
import { showModal } from "../../../../../../../../../../../store/modalSlice";
import { MODAL_ID } from "../../../../../../../../../../../utils/constants";

/**
 * @desc Product delete handlers.
 */
export const useHandlers = ({ product }) => {
  const dispatch = useDispatch();

  // HANDLERS -----------------------------------------------------------------

  /**
   * @desc Display a modal to delete a product.
   */
  const handleClick = () => {
    dispatch(
      showModal({
        id: `${MODAL_ID.DELETE_PRODUCT}-${product.sku}`,
      })
    );
  };

  // HOOK ---------------------------------------------------------------------

  return { handleClick };
};
